/* voyagio.js — comportements globaux du theme Atelier Maroquia.
   - Ajout au panier delegue (.vg-add) : /cart/add.js puis etat "Ajoute au panier".
   - Compte a rebours "cette semaine" (fin dimanche 23:59:59) pour la barre d'annonce.
   Aucun emoji, aucun tiret cadratin. */
(function () {
  "use strict";

  // Ajout au panier delegue (cartes produit + carrousels).
  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest(".vg-add") : null;
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute("data-variant");
    var qty = parseInt(btn.getAttribute("data-qty"), 10) || 1;
    if (!id || btn.disabled) return;
    btn.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }),
    })
      .then(function () {
        var label = btn.querySelector(".vg-add__label");
        btn.classList.remove("vg-btn--accent");
        btn.classList.add("vg-btn--ok");
        if (label) label.textContent = "Ajoute au panier";
        // Rafraichit le compteur panier du header.
        updateCartCount();
        setTimeout(function () {
          btn.classList.add("vg-btn--accent");
          btn.classList.remove("vg-btn--ok");
          if (label) label.textContent = "Ajouter au panier";
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.disabled = false;
      });
  });

  function updateCartCount() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.querySelector("[data-vg-cart-count]");
        if (!el) return;
        var n = cart.item_count || 0;
        el.textContent = n;
        el.hidden = n === 0;
      })
      .catch(function () {});
  }

  // Compte a rebours "Fin dans ..." (fin de semaine, dimanche 23:59:59).
  function endOfWeek() {
    var now = new Date();
    var end = new Date(now);
    var days = (7 - now.getDay()) % 7; // 0 = dimanche
    end.setDate(now.getDate() + days);
    end.setHours(23, 59, 59, 0);
    if (end < now) end.setDate(end.getDate() + 7);
    return end;
  }
  var cd = document.querySelectorAll("[data-vg-countdown-week]");
  if (cd.length) {
    var tick = function () {
      var end = endOfWeek();
      var s = Math.max(0, Math.floor((end - new Date()) / 1000));
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      var pad = function (n) { return (n < 10 ? "0" : "") + n; };
      var txt = d + "j " + pad(h) + "h " + pad(m) + "m " + pad(sec) + "s";
      cd.forEach(function (el) { el.textContent = txt; });
    };
    tick();
    setInterval(tick, 1000);
  }

  document.addEventListener("DOMContentLoaded", updateCartCount);
})();
